/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".queue-container .queue-field-wrapper{margin-top:20px}.queue-container .layout-row{font-size:14px;position:relative}.queue-container .layout-row.disabled label{opacity:.7}.queue-container .layout-row .mat-error{position:absolute;left:0;bottom:5px;font-size:12px}.queue-container .layout-row label{font-size:14px;width:100%;margin-bottom:15px}.queue-container .layout-row.input-wrap{padding:0 1.2em;min-width:6.5em}"];
export { styles as styles };
